import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ConfirmationService } from 'primeng/api';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { ResourceModel } from 'projects/core/src/lib/models/resource.model';
import { MorphModel } from 'projects/core/src/lib/models/morph.model';
import * as FileSaver from 'file-saver';
import { AppService } from '../../../services/app.service';

@Component({
  selector: 'app-file-handling',
  templateUrl: './file-handling.component.html',
  styleUrls: ['./file-handling.component.scss']
})
export class FileHandlingComponent implements OnInit {

  @Input() owner: any = null;
  @Input() ownerType: MorphModel = null;
  @Input() mode: string = null;
  @Input() type: string = null;
  @Input() accept: string = '.jpg,.png,.gif,.pdf,.doc,.docx,.mp4,.webm,.ogv';
  @Output() filesUpload = new EventEmitter<ResourceModel[]>();
  @Output() fileDelete = new EventEmitter<ResourceModel[]>();
  @ViewChild('upload') uploadComponent: any;

  public uploadOpened = false;
  public submitting = false;
  public uploadInheritVisible = false;
  public uploadInheritResources: any = null;
  public deleteInheritVisible = false;
  public deleteInheritResource: ResourceModel = null;
  public deleteInheritList: Array<ResourceModel> = [];

  constructor(
    private api: ApiService,
    private auth: AuthStateService,
    private ui: UiService,
    private confirmation: ConfirmationService,
    private transloco: TranslocoService,
    public app: AppService
  ) { }

  ngOnInit(): void {
  }

  openFileUpload(): void {
    if (this.mode === 'reporttemplates') {
      if (this.auth.hasRight('admin.reporttemplate.upload')) {
        this.uploadOpened = true;
      }
      return;
    }
    if (this.auth.hasRight('admin.ac.edit')) {
      this.uploadOpened = true;
    }
  }

  downloadFile(resource: ResourceModel): void {
    if (this.auth.hasRight('admin.document.download')) {
      this.api
        .downloadFile(
          resource.id,
          this.ownerType?.type || this.type || null,
          this.ownerType?.id || null,
        )
        .subscribe({
          next: (response: any) => {
            const blob = new Blob([response]);
            FileSaver.saveAs(blob, resource.public_name);
          }
        });
    }
  }

  onDeleteFile(list: Array<ResourceModel>, resource: ResourceModel): void {
    if (this.auth.hasRight('admin.document.delete')) {
      this.confirmation.confirm({
        message: this.transloco.translate('common.messages.really_delete', { value: resource.public_name }),
        header: this.transloco.translate('common.really_delete'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.deleteInheritResource = resource;
          this.deleteInheritList = list;
          if (this.owner?.shouldShowInheritDialog(this.mode)) {
            this.deleteInheritVisible = true;
          } else {
            this.deleteFile(false);
          }
        }
      });
    }
  }

  onStartUpload(): void {
    this.uploadComponent.upload();
  }

  onUploadFiles(event: any): void {
    this.uploadInheritResources = event;
    if (this.owner?.shouldShowInheritDialog(this.mode)) {
      this.uploadInheritVisible = true
    } else {
      this.uploadFiles(false);
    }
  }

  uploadFiles(inherit: boolean = false): void {
    this.submitting = true;
    this.api.uploadFiles(
      this.uploadInheritResources?.files,
      this.ownerType?.type || this.type || null,
      this.ownerType?.id || null,
      null,
      false,
      inherit
    ).subscribe({
      next: (result: any) => {
        if (result.data?.length > 0) {
          let message = this.transloco.translate('partials.file_handling.files_added', { number: this.uploadInheritResources?.files.length });
          const files: Array<ResourceModel> = [];
          result.data.forEach((resource: any) => {
            files.push(new ResourceModel().deserialize(resource));
            if (this.uploadInheritResources.files?.length === 1) {
              message = this.transloco.translate('partials.file_handling.file_added', { value: resource.public_name });
            }
          });
          this.uploadComponent.clear();
          this.uploadOpened = false;
          this.ui.toastSuccess(message, this.transloco.translate('common.added'));
          this.filesUpload.emit(files);
        } else {
          this.ui.toastError(this.transloco.translate('partials.file_handling.upload_error'));
        }
      },
      error: (error: any) => {
        this.ui.toastError(this.transloco.translate('partials.file_handling.upload_error'));
      }
    }).add(() => {
      this.submitting = false;
    });
  }

  deleteFile(inherit: boolean = false): void {
    this.api
      .deleteFile(
        this.deleteInheritResource.id,
        this.ownerType?.type || this.type || null,
        this.ownerType?.id || null,
        inherit
      )
      .subscribe({
        next: () => {
          this.ui.toastSuccess(
            this.transloco.translate('common.messages.deleted', { value: this.deleteInheritResource.public_name }),
            this.transloco.translate('common.deleted')
          );
          this.deleteInheritList.splice(this.deleteInheritList.indexOf(this.deleteInheritResource), 1);
          this.fileDelete.emit(this.deleteInheritList);
        },
        error: (error: any) => {
          this.ui.toastError(this.transloco.translate(error.message));
        }
      });

  }

}
